import React from 'react';
import styles from './Field.module.css';

export default function Field({
  label,
  optional,
  id,
  error,
  children,
}) {
  return (
    <div className={styles.group}>
      <label className={styles.label} htmlFor={id}>
        {label}
        {optional && <span className={styles.opt}> (opcional)</span>}
      </label>
      {children}
      {error && <p className={styles.err} role="alert">{error}</p>}
    </div>
  );
}
